import store from '@Store';
import { isLocal } from '@Constants/BuildInfo';
import { REAXYS_ROOT_DOMAINS } from '@Constants';
import { FEATURES } from '@Constants/rx-ui/constants';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { generateTraceHeaders } from '@Services/CorrelationId';
import Auth from '@Services/Auth';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';

const isReaxysDomain = () => {
  if (isLocal()) {
    return true; // In local development, we assume it's a Reaxys domain
  }
  return REAXYS_ROOT_DOMAINS.some((domain) => window.location.hostname.endsWith(domain));
};

function showErrorToastMessage() {
  store.dispatch(
    newToastMessage({
      title: 'Reaxys AI Search Access Error',
      content:
        'An error occurred while trying to access Reaxys AI Search. Please try again later or if the problem persists, please contact contact the Reaxys Customer Care Team.',
    })
  );
}

export function isTexelAccessEnabled() {
  return Auth.isFeatureEnabled(FEATURES.texel_access_enabled) && isReaxysDomain() && !Auth.isAnonymousUser();
}

export async function redirectToTexel() {
  try {
    const accessToken = Auth.getAccessToken();
    // Using fetch here instead of MessageBroker.send to get the redirect URL,
    // because browser follows redirect seamlessly, so we're getting responsr not from /linkout but from destination redirect URL.
    const response = await fetch(RequestUrls.texelLinkout.url, {
      method: RequestUrls.texelLinkout.method,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...generateTraceHeaders(),
      },
    });

    if (response.redirected) {
      window.open(response.url, '_blank');
    } else {
      Logger.error('Texel redirect - linkout is not redirected:', response);
      showErrorToastMessage();
    }
  } catch (err) {
    Logger.error('Texel redirect - error:', err);
    showErrorToastMessage();
  }
}
